import React from 'react';
import { Layout, Menu, Avatar, Dropdown, Button } from 'antd';
import { HomeOutlined, EditOutlined, FolderOutlined, LoginOutlined, UserAddOutlined } from '@ant-design/icons';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import './index.css';

const { Header: AntHeader } = Layout;

const AppHeader = ({ loggedInUser, onLogout }) => {
  const navigate = useNavigate();

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人中心'
    },
    {
      key: 'write',
      icon: <EditOutlined />,
      label: '写文章'
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: onLogout
    }
  ];

  return (
    <AntHeader className="app-header">
      <div className="header-container">
        <div className="header-logo">
          <Link to="/">My BlogShare</Link>
        </div>
        <Menu mode="horizontal" theme="dark" className="header-menu" selectedKeys={[]}>
          <Menu.Item key="home" icon={<HomeOutlined />}>
            <Link to="/">首页</Link>
          </Menu.Item>
          <Menu.Item key="archive" icon={<FolderOutlined />}>
            <Link to="/archive">归档</Link>
          </Menu.Item>
          <Menu.Item key="about">
            <Link to="/about">关于</Link>
          </Menu.Item>
          {loggedInUser && (
            <Menu.Item key="write" icon={<EditOutlined />}>
              <Link to="/write">写文章</Link>
            </Menu.Item>
          )}
        </Menu>
        <div className="header-actions">
          {loggedInUser ? (
            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
              <div className="user-info">
                <Avatar src={loggedInUser.avatar} icon={<UserOutlined />} size="default" />
                <span className="username">{loggedInUser.username}</span>
              </div>
            </Dropdown>
          ) : (
            <div className="guest-actions">
              <Button type="text" icon={<LoginOutlined />} onClick={() => navigate('/auth')} className="auth-btn">登录</Button>
              <Button type="primary" icon={<UserAddOutlined />} onClick={() => navigate('/auth')}>注册</Button>
            </div>
          )}
        </div>
      </div>
    </AntHeader>
  );
};

export default AppHeader;